// src/modules/app-views/ticket-events/pages/Document/tabs/RecordTab/index.jsx
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';
import EventInfoCard from './EventInfoCard';
import PricingConfigCard from './PricingConfigCard';

const TicketEventsRecordTab = () => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { data, loading } = useDocumentContext();

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="ticketEventRecord" isFetching={loading} data={data} />
      <EventInfoCard />
      <PricingConfigCard />
    </div>
  );
};

export default TicketEventsRecordTab;
